import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const admitad = {
  generateDeeplink: lazyModuleMethod(
    () => import('./generateDeeplink'),
    'default'
  ),
}
